import useSurveyLocale from '@aytm/app/swidget/base/modules/locale/useSurveyLocale'
import useViewport from '@aytm/app/swidget/base/modules/viewport/useViewport.ts'
import { IEcommerceAnswerSchema } from '../../types.ts'
import style from './Badges.module.scss'

interface IBadgesProps {
  answer: IEcommerceAnswerSchema
  // Where the labels sit is the host's business: over the card's photo, or in a row above a basket line.
  className?: string
}

// New (solid) and Marketplace (outline), the two labels a product can carry.
const Badges = ({ answer, className = '' }: IBadgesProps) => {
  const { t } = useSurveyLocale()
  const viewport = useViewport()

  if (!answer.overal_pick && !answer.amazon_choice) return null

  return (
    <div className={`${style.badges} ${viewport.mobile ? style.mobile : ''} ${className}`}>
      {answer.overal_pick && <span className={style.badgeNew}>{t('questions', 'ec', 'tesco', 'badgeNew')}</span>}
      {answer.amazon_choice && (
        <span className={style.badgeMarketplace}>
          {t('questions', 'ec', 'tesco', 'badgeMarketplace')}
          <span className={style.fullstop}>.</span>
        </span>
      )}
    </div>
  )
}

export default Badges
